import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoice.Save.IRequest;
type Response = Api.Sales.ContractRefundInvoice.Save.IResponse;
type Headers = Api.Sales.ContractRefundInvoice.Save.IHeaders;
const url = '/api/Sales/ContractRefundInvoice';
export default async function contractRefundInvoiceSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
